// Stub file - original was experimental/broken
import { Order } from '../../types';

const PENDING_STATES = ['pending', 'waiting_confirmation', 'payment_pending'];
const READY_STATES = ['ready', 'confirmed', 'scheduled_confirmed'];

export const getOrderStatus = (order: Order) => ({
    isPending: PENDING_STATES.includes(order.status),
    isReady: order.isReady === true || order.status === 'ready',
    isPaymentPending: order.status === 'payment_pending',
    isWaitingPickup: order.status === 'assigned' || order.status === 'dispatched',
    isReturned: order.status === 'returned',
    isCanceled: order.status === 'canceled'
});

const ONLINE_METHODS = ['pix', 'online', 'pago', 'ifood'];
const CASH_METHODS = ['dinheiro', 'espécie', 'cash'];

export const getPaymentStatus = (method: string = '') => ({
    isPaid: ONLINE_METHODS.some(m => method.toLowerCase().includes(m)),
    isCash: CASH_METHODS.some(m => method.toLowerCase().includes(m)),
    isCard: method.toLowerCase().includes('cartão') || method.toLowerCase().includes('card')
});
